import { DataTableExpandedRows } from 'primereact/datatable';
import {useMemo, useState } from 'react';
import { UserAccessRightsResponseModel } from '../../../models/users/UserAccessRightsResponseModel';
import { IHttpService, HttpService } from '../../../services/httpService';
import {
	INotifierService,
	NotifierService
} from '../../../services/notifierService';
import { UsersAccessRightsListingResponseModel } from '../../../models/users/UsersAccessRightsListingResponseModel';
import { PaginatorPageState } from 'primereact/paginator';

export const useUsersAccessRightsExpanded = (
	users: UsersAccessRightsListingResponseModel[],
	setUsers: React.Dispatch<
		React.SetStateAction<UsersAccessRightsListingResponseModel[]>
	>
) => {
    const rowsOnPage = 25;

	const httpService: IHttpService = useMemo(() => new HttpService(), []);
	const notifierService: INotifierService = useMemo(
		() => new NotifierService(),
		[]
	);

	const [expandedRows, setExpandedRows] = useState<
		DataTableExpandedRows | undefined
	>(undefined);

	const setRightsForUser = (
		userId: number,
        first: number,
		rights: UserAccessRightsResponseModel
	) => {
		setUsers((prevUsers) => {
			const userToUpdate = prevUsers.find((user) => user.id === userId);

			if (!userToUpdate) {
				return prevUsers;
			}

			userToUpdate.rights = {
                ...userToUpdate.rights,
				models: rights.models,
				total: rights.total,
				page: rights.page === 0 ? 0 : rights.page - 1,
                first: first,
			};

			return [...prevUsers];
		});
	};

	const fetchUserAccessRights = (id: number, page: number, first: number) => {
		const user = users.find(
			(x) => x.id === id
		);

		if (!user) {
			return;
		}

		httpService
			.get<UserAccessRightsResponseModel>(
				`users/userAccessRights?page=${page}&sortBy=country&order=asc&userId=${id}&pageSize=${rowsOnPage}`,
				undefined
			)
			.then((accessRights) => {
				setRightsForUser(id, first, accessRights);
			})
			.catch((err) => notifierService.error());
	};

	const deleteAccessRight = (id: number, userId: number) => {
		httpService
			.delete(`countryBrandRights/${id}`, undefined)
			.catch(() => notifierService.error())
			.finally(() => fetchUserAccessRights(userId, 1, 0));
	};

    const onRowToggle = (e: any) => {
		setExpandedRows(e.data);
	};

	const onRowExpand = (e: any) => {
		fetchUserAccessRights(e.data.id, 1, 0);
	};

	const onPageExpandedChange = (event: PaginatorPageState, id: number) => {
		fetchUserAccessRights(id, event.page + 1, event.first);
	};

	return {
		expandedRows,
		onRowToggle,
        onPageExpandedChange,
        onRowExpand,
        fetchUserAccessRights,
		deleteAccessRight
	};
};
